import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SceneLeftMenuIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 16,
    width,
    height,
    color = 'currentColor',
    onClick,
    strokeWidth = 1.5,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <rect
        x="9"
        y="9"
        width="6"
        height="6"
        rx="1"
        stroke={color}
        strokeWidth={strokeWidth}
      />
      <path
        d="M4 8V5h3M20 8V5h-3M4 16v3h3M20 16v3h-3"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

SceneLeftMenuIcon.displayName = 'SceneLeftMenuIcon';
